import { Technician } from '@agroone/entities'
import { Observable } from 'rxjs'
import { UserNetworkService } from '../user/user.network.service'
import { Injectable, inject } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class TechniciansService {
  private userNetworkService = inject(UserNetworkService)

  public getTechnicians(): Observable<Technician[]> {
    return this.userNetworkService.getTechnicians()
  }
}
